import React, { useEffect } from 'react';
import { WelcomeScreen } from './components/welcome/WelcomeScreen';
import { NewProjectDialog } from './components/new-project/NewProjectDialog';
import { MainEditor } from './components/editor/MainEditor';
import { LoginScreen } from './components/auth/LoginScreen';
import { useAppStore } from './store';
import { useAuthStore } from './store/authStore';
import { AssetImportDialog } from './components/dialogs/asset-import';
import { BuildExportDialog } from './components/dialogs/build-export';

const App: React.FC = () => {
  const { currentView, isNewProjectDialogOpen, closeNewProjectDialog } = useAppStore();
  const authStatus = useAuthStore((s) => s.status);
  const checkAuth = useAuthStore((s) => s.checkAuth);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  // Show nothing while checking token
  if (authStatus === 'checking') {
    return (
      <div className="flex items-center justify-center h-screen w-screen bg-gray-900">
        <div className="animate-spin h-8 w-8 border-2 border-blue-500 border-t-transparent rounded-full" />
      </div>
    );
  }

  // Show login screen if not authenticated
  if (authStatus === 'unauthenticated') {
    return <LoginScreen />;
  }

  return (
    <div className="h-screen w-screen overflow-hidden">
      {/* Welcome Screen */}
      {currentView === 'welcome' && <WelcomeScreen />}

      {/* Main Editor */}
      {currentView === 'editor' && <MainEditor />}

      {/* New Project Dialog */}
      <NewProjectDialog
        isOpen={isNewProjectDialogOpen}
        onClose={closeNewProjectDialog}
      />

      {/* Asset Import Dialog - reads isOpen from store */}
      <AssetImportDialog />

      {/* Build/Export Dialog - reads isOpen from store */}
      <BuildExportDialog />
    </div>
  );
};

export default App;
